import svelte from "../assets/images/repositories/svelte.gif";
import login from "../assets/images/repositories/login.png";

export const repositories = [
  {
    title: "Next app",
    description: "use NextJS implement third party login",
    cover: login,
    technologies: ["react", "chakraUi"],
    url: "https://github.com/ruofanwei/next-app",
    live: "https://blog.errorbaker.tw/posts/ruofan/next-auth/",
    blurHash: "L25#he^nryxc^-w$V{V_56bqx[M{",
    stars: "0",
    fork: "0",
  },
  {
    title: "svelte app",
    description: "use svelte implement third party login",
    cover: svelte,
    technologies: ["Svelte", "xstate", "tailwind"],
    url: "https://github.com/ruofanwei/svelte-xstate-app",
    live: "https://blog.errorbaker.tw/posts/ruofan/svelte/",
    blurHash: "L25#he^nryxc^-w$V{V_56bqx[M{",
    stars: "0",
    fork: "0",
  },
];
